<template>
  <el-pagination class="pagination-container" background @size-change="handleSizeChange" @current-change="handleCurrentChange" v-model:current-page="pageNum" :page-sizes="pageSizes" v-model:page-size="pageSize" :layout="layout" :total="Number(total)"></el-pagination>
</template>

<script>

export default {
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },
  computed: {
    pageNum: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.size
      },
      set(val) {
        this.$emit('update:size', val)
      }
    }
  },
  methods: {
    handleSizeChange(newSize) {
      this.$emit('pagination', { page: this.pageNum, size: newSize })
    },
    handleCurrentChange(newPage) {
      this.$emit('pagination', { page: newPage, size: this.pageSize })
    }
  }
}
</script>

<style lang="less" scoped>
.pagination-container {
  padding: 16px 0;
}
</style>
